import * as Notification from './components/Notification.css';
import * as PromoNotification from './components/PromoNotification/PromoNotification.css';

export default {
	Notification,
	PromoNotification
};
